import * as _ from 'lodash-es';
import React from 'react';
import { DragTypes, MoveStates } from '../constants';
import type { TopicReorganizationTree } from '../useTopicReorganization';
import type { ContentMapGetDropParams } from '../utils/types';
import TopicTreeCardDropSeparator from './TopicTreeCardDropSeparator';
import * as styles from './TopicTreeCardDropSeparatorStack.module.scss';

const CARD_LEVEL_INDENT = parseInt(styles.cardLevelIndent, 10);

const getTreeDepth = (tree: TopicReorganizationTree) => {
  let depth = 0;
  let current: TopicReorganizationTree | undefined = tree;
  while (current) {
    depth += 1;
    current = current.parentTree;
  }
  return depth - 1;
};

interface TopicTreeCardDropSeparatorStackProps {
  tree: TopicReorganizationTree;
  expanded: boolean;
  getDropParams: ContentMapGetDropParams;
}

const TopicTreeCardDropSeparatorStack = ({
  tree,
  expanded,
  getDropParams,
}: TopicTreeCardDropSeparatorStackProps) => {
  const dropTargetTopics = [];
  const treeDepth = getTreeDepth(tree);

  if (
    expanded &&
    tree.reorganizationMetadata.move.state !== MoveStates.movedOut &&
    tree.children.length
  ) {
    dropTargetTopics.push({
      tree,
      indexWithPlaceholder: 0,
      depth: treeDepth + 1,
    });
  } else {
    let current = tree;
    let currentDepth = treeDepth;
    while (current?.parentTree?.parentTree) {
      dropTargetTopics.unshift({
        tree: current.parentTree,
        indexWithPlaceholder: current.parentTree.children.indexOf(current) + 1,
        depth: currentDepth,
      });

      if (_.last(current.parentTree.children) !== current) {
        break;
      }

      current = current.parentTree;
      currentDepth -= 1;
    }
  }

  return (
    <div className={styles.container}>
      {dropTargetTopics.map(
        ({ tree: destinationTree, depth, indexWithPlaceholder }) => (
          <div
            key={depth}
            style={{
              marginLeft:
                (!Number.isNaN(CARD_LEVEL_INDENT) ? CARD_LEVEL_INDENT : 0) *
                (depth - 1),
            }}
          >
            <TopicTreeCardDropSeparator
              {...getDropParams([DragTypes.topics, DragTypes.column], {
                destinationTree,
                indexWithPlaceholder,
              })}
            />
          </div>
        ),
      )}
    </div>
  );
};

export default TopicTreeCardDropSeparatorStack;
